import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Working = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 250, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 120%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='workingmainprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="workingmainchld">

                        <div className="imgleftworking displaynoneonmobile">
                            <img className='img-fluid' src="\assets\Createprofile\createprofileiworkimg.png" alt="img" />
                        </div>
                        <div className="imgleftworking d-none displayshowonmobile" style={{position: "relative", zIndex: "9"}}>
                            <img className='img-fluid d-block m-auto' src="\assets\Createprofile\createprofileiworkimgmbl.png" alt="img" style={{maxWidth: "60%"}} />
                            <img className='img-fluid mblbgviewcenterbackside' src="\assets\Createprofile\createprofileiworkimgmblbackside.png" alt="img" />
                        </div>

                        <div className="rightcntworking">
                            <h2>How It Works</h2>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[0] = el)}>
                                <h3>1. Set Up Your Profile</h3>
                                <p>Choose a profile picture, add your name, and fill out your bio and interests.</p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[1] = el)}>
                                <h3>2. Customize Visibility</h3>
                                <p>Adjust privacy settings to control who can see specific information.</p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[2] = el)}>
                                <h3>3. Engage with the Community</h3>
                                <p>Use your profile to join groups, participate in discussions, and share updates.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Working